import { render, staticRenderFns } from "./info_chatbot.vue?vue&type=template&id=b87c2b1c&scoped=true&"
import script from "./info_chatbot.vue?vue&type=script&lang=js&"
export * from "./info_chatbot.vue?vue&type=script&lang=js&"
import style0 from "./info_chatbot.vue?vue&type=style&index=0&id=b87c2b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87c2b1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
